import React from 'react';
import SuperAdminOnlyRoute from './SuperAdminOnlyRoute';

interface PlatformOrgAdminRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/** Routes for the super-admin dashboard org tab and linked org tools. */
const PlatformOrgAdminRoute: React.FC<PlatformOrgAdminRouteProps> = ({ children, redirectTo }) => (
  <SuperAdminOnlyRoute allowOrgAdmin redirectTo={redirectTo}>
    {children}
  </SuperAdminOnlyRoute>
);

export default PlatformOrgAdminRoute;
